import { connect } from 'react-redux'
import BillingAccounts from './BillingAccounts'
import showBillingCreateFormModal from 'features/Billing/BillingCreateFormModal'

const stateToProps = ({ auth }) => ({
  user: auth.user,
})

const dispatchToProps = {
  showBillingCreateFormModal,
}

export default connect(stateToProps, dispatchToProps)(BillingAccounts)



// WEBPACK FOOTER //
// ./src/pages/BillingAccounts/BillingAccounts.container.js